import { useNavigate } from "react-router-dom";
import { ChevronLeft } from "lucide-react";

export function Breadcrumb({ label = "Back", to }) {
  const navigate = useNavigate();
  return (
    <div className="border-b border-zinc-800/60 bg-[#0a0a0c]/60">
      <div className="mx-auto max-w-7xl px-4 py-3 sm:px-6 lg:px-8">
        <button
          data-testid="breadcrumb-back"
          onClick={() => (to ? navigate(to) : navigate(-1))}
          className="inline-flex items-center gap-1.5 text-sm font-medium text-zinc-400 transition-colors hover:text-white"
        >
          <ChevronLeft className="h-4 w-4" /> {label}
        </button>
      </div>
    </div>
  );
}
